
import { useEffect } from 'react';

import { Layout } from '../../../components';
import { CreateCreditPolicyPanel } from '../../../components/panels';
import { DRAWER_KEYS } from '../../../store/constants';

/**
 * Renders the Create Credit Policy Page.
 *
 * This component displays the Create Credit Policy Page, which includes an app bar, a drawer, and a create credit policy panel.
 * The page title is set to "Nova Política de Crédito | LCD".
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered CreateCreditPolicyPage.
 */
const CreateCreditPolicyPage = () => {

    useEffect(() => {
        document.title = 'Nova Política de Crédito | LCD'
    }, [])

    return (
        <Layout selectedKey={DRAWER_KEYS.CREDIT_POLICIES_CREATE}>
            <CreateCreditPolicyPanel />
        </Layout>
    )
}

export default CreateCreditPolicyPage